/* eslint eqeqeq: 'off' */
import * as url from '../../api/url';
import APIutil from '../../api/APIutils';
import {initAmplitude} from 'amplitude/amplitude';
import * as types from '../../action/actionTypes';
import {global_error_handling} from '../GlobalErrorMgmtAction';
import { GetLicenseInformation, GetTenantWorkOrderLicenseInfo } from './administrationAction';


export function getServerType(featureName){
    return function (dispatch){
        return APIutil.getDataAPI(url.get_license_info).then(response =>{
            dispatch(global_error_handling(response)); 
            let dataReturned = "DEV";
            if(response !== null && response !== undefined && response[0] !== undefined){
                (response[0].customerCode==="" ||response[0].customerCode==="0")?dataReturned = "DEV":dataReturned = "PROD";
                if(response[0].productType !== null && response[0].productType !== undefined && response[0].productType.toLowerCase() === "hosted")
                {
                    dataReturned = "PROD";
                }
            }
            initAmplitude("REACT_APP_AMPLITUDE_API_KEY_"+featureName+"_"+dataReturned);
        }).catch(error => { throw error; })
    }
}

export function getInstanceType(){

    return function (dispatch){
        return APIutil.getDataAPI(url.get_instance_type).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response,types.GET_INSTANCETYPE));
        }).catch(error => {
            throw error;
        })
    }   
}

export function getDevicePanelDetails(){
    return function(dispatch){
        return APIutil.getDataAPI(url.get_device_panel_details).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_DEVICE_PANEL_DETAILS));
        }).catch(error => {
            throw error;
        })
    }
}

export function activatePanelLicense(data){
    return function(dispatch){
        return APIutil.postData(url.activate_license_panel,data).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined && response.status === 200){
                dispatch(getDevicePanelDetails());
                dispatch(GetLicenseInformation());
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function deactivatePanelLicense(data){
    return function(dispatch){
        return APIutil.postData(url.deactivate_license_panel,data).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined && response.status === 200){
                dispatch(getDevicePanelDetails());
                dispatch(GetLicenseInformation());
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function UpdateCloudLicenseCache(){
    return function(dispatch){
        return APIutil.postData(url.update_license_cache).then(response => {
            dispatch(global_error_handling(response));
            if(response !== null && response !== undefined && response.status === 200){
                dispatch(getDevicePanelDetails());
                dispatch(GetLicenseInformation());
                dispatch(GetTenantWorkOrderLicenseInfo());
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}

